// المكاتب المسجَّلة (0055) — تُقرأ مرّةً عند فتح الشاشة، وتُقاس بها مسافة كل بصمة.
// وفشل القراءة لا يُعطّل الشاشة: بلا مكاتب تبقى المنطقة وحدها ولا تُقال مسافة.
import { useEffect, useState } from 'react';
import { get, type OfficeLocation } from './api.ts';
import type { Office } from './geoAreas.ts';

export function useOffices(): Office[] {
  const [offices, setOffices] = useState<Office[]>([]);
  useEffect(() => {
    let alive = true;
    void (async () => {
      try {
        const r = await get<{ items: OfficeLocation[] }>('/offices');
        if (alive) setOffices(r.items.filter(o => o.isActive !== false).map(o => ({ id: o.id, nameAr: o.nameAr, lat: o.lat, lon: o.lon, radiusM: o.radiusM })));
      } catch { /* بلا مكاتب: المنطقة وحدها */ }
    })();
    return () => { alive = false; };
  }, []);
  return offices;
}
